import React from "react";
import {useTranslation} from "react-i18next";
import {SelectField} from "../../../_defaultComponents/FilterComponents/FilterComponentStyles";

const collectionStatuses = ["all", "PENDING", "SUCCESS", "CANCELLED"];

export const CollectionStatusFilter = ({value, onChange}) => {
    const {t} = useTranslation();
    return (
        <React.Fragment>
            <h5>{t("collectionStatusFilter.title", {ns: "codPayment"})}</h5>
            <SelectField value={value} data-testid="collectionStatus" onChange={onChange}>
                {collectionStatuses.map(status => (
                    <SelectField.Option data-testid="status_option" value={status} key={status}>
                        {t(`collectionStatusFilter.${status}`, {ns: "codPayment"})}
                    </SelectField.Option>
                ))}
            </SelectField>
        </React.Fragment>
    );
};
